module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel8-c1d8fd11318ba22010729d5245b8caa1.jpg";